class SignUpOffer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.setPromo();
  }

  async setPromo() {
    const baseProduct = await window.__CGC.signUp.getProduct(true);
    const discountCode = await window.__CGC.signUp.getDiscountCode(true);

    this.discountCode = discountCode;
    this.product = baseProduct;

    if (this.discountCode) {
      const applicableOffers = offers.filter((offer) =>
        offer.applicable_discounts.some((code) => code === this.discountCode)
      );

      if (applicableOffers.length > 0) {
        // Find the offer applicable to the selected product
        const offer = applicableOffers.find((offer) =>
          offer.handle_associations.some((association) => association === this.product)
        );

        if (offer && offer.price) {
          this.offer = offer;
        }
      } else {
        const offer = applicableOffers[0];

        if (offer && offer.price) {
          this.offer = offer;
        }
      }

      const rejoinOffer = rejoinOffers.find((offer) =>
        offer.applicable_discounts.some((code) => code === this.discountCode)
      );

      if (rejoinOffer && rejoinOffer.price) {
        this.offer = rejoinOffer;
      }
    }

    if (!this.offer) {
      // find default offer for selected product
      this.offer = defaultOffers[this.product];
    }

    this.render();
  }

  render() {
    const { offer } = this;

    this.querySelector('[data-content="offer.heading"]').innerText = offer.heading;
    this.querySelector('[data-content="offer.product_title"]').innerText = offer.product_title;

    this.querySelector('[data-content="offer.strikethrough_price"]').innerText = offer.strikethrough_price;
    this.querySelector('[data-content="offer.price"]').innerText = offer.price;

    this.querySelector('img[data-content="offer.image"]').src = offer.image;

    this.querySelector('[data-content="offer.description"]').innerText = offer.description;

    this.querySelectorAll('.sign-up__promo-skeleton').forEach((skeleton) => {
      // Add fade-out transition
      skeleton.style.transition = 'opacity 300ms';
      skeleton.style.opacity = '0';
      setTimeout(() => {
        skeleton.classList.remove('sign-up__promo-skeleton');
        skeleton.style.transition = '';
        skeleton.style.opacity = '';
      }, 300);
    });
  }
}

customElements.define('sign-up-offer', SignUpOffer);
